import types from "./types";

export const setParentSection = (section) => {
  return {
    type: types.SET_PARENT_SECTION,
    section,
  };
};

export const resetParentSection = () => {
  return {
    type: types.RESET_PARENT_SECTION,
  };
};
